$(document).on('click', '.js-articles-load-more', function(e) {
    e.preventDefault();

    var $button = $(this),
        $container = $('.archive_main'),
        offset = $button.attr('data-offset'),
        category = $button.attr('data-category');

        $button.prop('disabled', true);
        $button.text('Loading...');

        $.ajax({
            url: ajaxurl,
            type: "POST",
            dataType: 'json',
            data: {'action' : 'posts_load_more', 'offset' : offset, 'category' : category},
            success: function (data) {
                console.log(data);
                
                $container.append(data.posts);

                if (data.hidebutton == true) {
                    $button.hide();

                    return;
                }

                $button.attr('data-offset', data.newoffset);

                $button.prop('disabled', false);
                $button.text('Load more');
            },
            error : function (e) {
                console.log(e);
            }
        });
});